import styled, { css } from 'styled-components';

const linkStyles = css`
    color: ${(props) => props.theme.palette.primaryA1};
    ${(props) => props.theme.typography.textMedium};
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
        text-decoration: underline;
        opacity: 0.5;
    }

    &.inherit-font {
        font: inherit;
    }

    &.dashed {
        border-bottom: 1px dashed ${(props) => props.theme.palette.primaryA1};

        &:hover {
            text-decoration: none;
        }
    }
`;

export const LinkStyled = styled.a`
    ${linkStyles};
`;

export const LinkButtonStyled = styled.button`
    padding: 0;
    border: none;
    border-radius: 0;
    background: none;
    text-align: left;
    ${linkStyles};
`;
